var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTi1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_70_1",
    "data-name": "Component 70 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#6bc961"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-alt",
    "data-name": "Icon awesome-file-alt",
    d: "M12.44,7.553V0H1.333A1.33,1.33,0,0,0,0,1.333V27.1a1.33,1.33,0,0,0,1.333,1.333h18.66A1.33,1.33,0,0,0,21.325,27.1V8.885H13.773A1.337,1.337,0,0,1,12.44,7.553Zm3.554,13.106a.668.668,0,0,1-.666.666H6a.668.668,0,0,1-.666-.666v-.444A.668.668,0,0,1,6,19.548h9.33a.668.668,0,0,1,.666.666Zm0-3.554a.668.668,0,0,1-.666.666H6a.668.668,0,0,1-.666-.666V16.66A.668.668,0,0,1,6,15.994h9.33a.668.668,0,0,1,.666.666Zm0-4v.444a.668.668,0,0,1-.666.666H6a.668.668,0,0,1-.666-.666v-.444A.668.668,0,0,1,6,12.44h9.33A.668.668,0,0,1,15.994,13.106ZM21.325,6.77v.339H14.217V0h.339A1.332,1.332,0,0,1,15.5.389l5.437,5.442A1.329,1.329,0,0,1,21.325,6.77Z",
    transform: "translate(18.837 14.783)",
    fill: "#eff5fe"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTi1);
export default __webpack_public_path__ + "static/media/ti1.7ed93fe64af548c717aa7f6a5525fa39.svg";
export { ForwardRef as ReactComponent };